import axios from "axios";

export default function () {
    const accountId = 7865490

    const loadPolicy = async (type) => {
        return axios.get(`https://www.iubenda.com/api/${type}/${accountId}/no-markup`)
    }

    const fallbackUrl = (type) => {
        return `https://www.iubenda.com/${type}/${accountId}`
    }

    return {
        accountId,
        loadPolicy,
        fallbackUrl,
    };
}
